import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    infoSection: {
        textAlign: "center",
        marginTop: theme.spacing(12),
    },
    stepsList: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
        marginBottom: theme.spacing(4),
    },
    stepRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: theme.spacing(2),
    },
    stepCircle: {
        border: "1px solid",
        borderRadius: "50%",
        height: theme.spacing(6),
        width: theme.spacing(6),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        marginTop: theme.spacing(0.5),
    },
    circleText: {
        fontWeight: 600,
    },
    stepText: {
        fontWeight: 400,
        flex: 1,
        textAlign: "left",
    },
    additionalInfo: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        padding: theme.spacing(3),
        backgroundColor: theme.palette.emteria.background.paper,
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.emteria.border.primary}`,
    },
    infoText: {
        color: theme.palette.emteria.primary,
        fontWeight: 400,
        textAlign: "center",
    },
    formSection: {
        width: "100%",
        marginBottom: theme.spacing(4),
    },
    footer: {
        textAlign: "center",
        width: "100%",
    },
    footerText: {
        color: theme.palette.emteria.text.secondary,
    },
}));
